import { combineReducers } from 'redux';

import admin_state from './admin';
import admin_finance_payments from './adminFinancePayments';
import my_profile from './aeMyProfile';
import activity_logs from './ae_activity_logs';
import admin_attendance_entries from './ae_admin_attendance_entries';
import admin_cp_list from './ae_admin_cp_list';
import admin_created_cp from './ae_admin_created_cp';
import admin_candidate_project from './ae_admin_project';
import admin_timesheet from './ae_admin_timesheet';
import admin_timesheets from './ae_admin_timesheets';
import all_jobs from './ae_all_jobs';
import applied_jobs_list from './ae_applied_jobs_list';
import apply_job from './ae_apply_job';
import assessment_ques from './ae_assessment_ques';
import attendance_entries from './ae_attendance_entries';
import candidate_profile from './ae_candidate_profile';
import candidate_projects from './ae_candidate_projects';
import job_details from './ae_job_details';
import my_referrals from './ae_my_referrals';
import otp_verification from './ae_otp_verification';
import parse_resume from './ae_parse_resume';
import payments from './ae_payments';
import phone_verification from './ae_phone_verification';
import admin_reports from './ae_reports';
import salary from './ae_salary';
import save_job from './ae_save_job';
import saved_jobs_list from './ae_saved_jobs_list';
import search_body from './ae_search_body';
import search_jobs from './ae_search_jobs';
import selected_timesheet from './ae_selected_timesheet';
import timesheets from './ae_timesheets';
import update_profile from './ae_update_profile';
import currentUser from './auth';
import googleMaps from './googleMaps';
import notifications from './notifications';
import toast from './toast';

const rootReducer = combineReducers({
  activity_logs,
  attendance_entries,
  candidate_projects,
  timesheets,
  payments,
  currentUser,
  phone_verification,
  otp_verification,
  my_profile,
  toast,
  googleMaps,
  notifications,
  update_profile,
  search_jobs,
  job_details,
  all_jobs,
  apply_job,
  applied_jobs_list,
  save_job,
  saved_jobs_list,
  my_referrals,
  salary,
  search_body,
  parse_resume,
  assessment_ques,
  admin_attendance_entries,
  admin_timesheets,
  admin_candidate_project,
  admin_cp_list,
  candidate_profile,
  admin_timesheet,
  admin_created_cp,
  admin_reports,
  selected_timesheet,
  admin_finance_payments,
  admin_state
});

export default rootReducer;
